module.exports = __webpack_public_path__ + "static/media/Akshit.18764f74.png";